<template>
  <header id="nav" class="nav nav--main">
    <div class="nav--main--left">

      <span class="cursor-pointer" @click="$router.push('/files')">
        <svg class="logo" height="448" viewBox="0 0 2406 448" width="2406" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><linearGradient id="a" gradientUnits="objectBoundingBox" x1=".5" x2=".5" y2="1"><stop offset="0" stop-color="#2cb894"/><stop offset="1" stop-color="#2cb894"/><stop offset="1" stop-color="#71d1b8"/></linearGradient><clipPath id="b"><path d="m0 0h2406v448h-2406z"/></clipPath><g clip-path="url(#b)"><g fill-rule="evenodd" transform="translate(1.65 -13.43)"><g fill="#71d1b8"><path d="m843.83 101.47a5.608 5.608 0 0 1 5.61-5.61h119.54q44.865 0 79.11 17.41 34.635 17.01 53.52 48.27 19.29 31.26 19.28 72.8t-19.28 72.81q-18.885 31.245-53.52 48.66-34.245 17.01-79.11 17.01h-119.54a5.6 5.6 0 0 1 -5.61-5.6zm122 218.73q41.325 0 65.73-22.95 24.8-23.34 24.79-62.91 0-39.555-24.79-62.51-24.405-23.34-65.73-23.34h-58.24v171.71z"/><path d="m1158.74 221.35a61.4 61.4 0 0 1 61.4-61.39v212.86h-61.4zm30.7-91.06q-16.92 0-27.55-9.9a32.159 32.159 0 0 1 -10.62-24.53 32.174 32.174 0 0 1 10.62-24.53q10.635-9.885 27.55-9.89t27.55 9.5a30.519 30.519 0 0 1 10.62 23.74q0 15.42-10.62 25.71-10.635 9.9-27.55 9.9z"/><path d="m1356.61 156.79q49.2 0 75.57 23.74 26.37 23.355 26.36 70.83v121.46h-57.45v-26.5q-17.325 29.67-64.55 29.67-24.39 0-42.5-8.31-17.715-8.31-27.16-22.95a59.991 59.991 0 0 1 -9.44-33.23q0-29.67 22.04-46.69 22.425-17.01 68.87-17.01h48.8q0-20.19-12.2-30.87-12.2-11.07-36.6-11.07a104.456 104.456 0 0 0 -33.45 5.54 85.143 85.143 0 0 0 -27.55 14.24l-19.83-38.81a5.4 5.4 0 0 1 1.81-7.03 136.626 136.626 0 0 1 37.3-16.28 187.418 187.418 0 0 1 49.98-6.73zm-4.72 177.66q15.75 0 27.94-7.13a40.893 40.893 0 0 0 17.32-21.76v-21.76h-42.11q-37.785 0-37.78 24.93a22.957 22.957 0 0 0 9.05 18.99q9.45 6.72 25.58 6.73z"/><path d="m1624.69 164.71q28.755 0 51.96 13.45a94.575 94.575 0 0 1 36.2 37.19q13.4 23.745 13.38 54.21 0 30.465-13.38 54.6a94.641 94.641 0 0 1 -36.2 37.19q-23.235 13.065-51.96 13.06-27.15 0-49.19-12.66a90.356 90.356 0 0 1 -34.24-36.01v123.84h-19.67v-264.4a18.887 18.887 0 0 1 18.89-18.89v48.67a88.99 88.99 0 0 1 34.24-36.8q22.425-13.455 49.97-13.45zm-1.17 191.89q23.61 0 42.5-11.08a77.484 77.484 0 0 0 29.51-30.86q11.04-19.785 11.02-45.1 0-25.32-11.02-45.11a77.548 77.548 0 0 0 -29.51-30.86q-18.9-11.085-42.5-11.08-23.625 0-42.51 11.08a81.222 81.222 0 0 0 -29.51 30.86q-10.635 19.785-10.63 45.11t10.63 45.1a81.15 81.15 0 0 0 29.51 30.86q18.9 11.085 42.51 11.08z"/><path d="m1800.15 211.4q9.45-22.56 29.52-34.43 20.055-12.255 48.79-12.26v19.38l-4.72-.39q-34.245 0-53.53 21.76-19.275 21.375-19.28 59.75v107.61h-19.67v-187.64a18.887 18.887 0 0 1 18.89-18.89z"/><path d="m1926.77 185.97a19.687 19.687 0 0 1 19.69-19.68v206.53h-19.69zm9.85-69.93a16.266 16.266 0 0 1 -11.42-4.35 16.186 16.186 0 1 1 22.83-22.95 14.446 14.446 0 0 1 4.73 11.08 15.7 15.7 0 0 1 -4.73 11.47 15.488 15.488 0 0 1 -11.41 4.75z"/><path d="m2123.84 164.71q38.565 0 61 22.55t22.44 64.89v120.67h-19.68v-119.09q0-34.815-17.71-53.02-17.31-18.2-48.79-18.2-36.21 0-57.07 21.76t-20.85 58.56v109.99h-19.69v-187.64a18.891 18.891 0 0 1 18.88-18.89v44.71a78.776 78.776 0 0 1 31.5-34.03q21.24-12.255 49.97-12.26z"/><path d="m2384.32 359.77a51.467 51.467 0 0 1 -18.89 11.08 75.153 75.153 0 0 1 -23.22 3.56q-26.76 0-41.32-14.64-14.58-15.045-14.57-41.55v-134.92h-37.78v-17.01h37.78v-25.43a19.679 19.679 0 0 1 19.69-19.67v45.1h65.33v17.01h-65.33v132.95q0 20.175 9.43 30.86 9.84 10.29 28.73 10.28 19.29 0 31.89-11.47z"/></g><path d="m576.22 204.15c.04 0 .07.04.05.07a.053.053 0 0 0 .06.07c1.39-.04 2.8-.07 4.21-.07 9.01 0 8.04 8-.97 8h-471.69c-5.47 0-6.65-6.54-1.35-7.91a4.742 4.742 0 0 1 1.24-.16zm-441.75 203.91c-64.95-4.06-116.12-49.11-116.12-104.09a89 89 0 0 1 9.82-40.52 9.587 9.587 0 0 1 8.62-5.16h634.71a9.6 9.6 0 0 1 8.67 5.24 95.859 95.859 0 0 1 10.06 42.64v.24c-.06 53.67-44.65 97.64-101.25 101.65zm-92.68-154.37a4.021 4.021 0 0 1 -3.25-6.49 4.132 4.132 0 0 1 3.25-1.58h624.96a4.126 4.126 0 0 1 3.27 1.61 4.027 4.027 0 0 1 -3.28 6.46zm13.02-13.83a4.008 4.008 0 0 1 -2.79-7 4.228 4.228 0 0 1 2.78-1.06h599.14a4.241 4.241 0 0 1 2.8 1.06 4.016 4.016 0 0 1 -2.81 7zm19.14-13.82a4 4 0 0 1 -2.2-7.47 4.29 4.29 0 0 1 2.17-.59h560.52a4.341 4.341 0 0 1 2.12.54c3.83 2.12 2.21 7.52-2.15 7.52zm123.59-132.25a4.68 4.68 0 0 1 1.48-.24h71.43a4.681 4.681 0 0 1 1.48.24c4.94 1.58 3.61 7.83-1.58 7.83h-71.23c-5.18 0-6.52-6.25-1.58-7.83zm252.63-69.36c6.74.81 5.82 8.07-.98 8.07h-37.05c-6.79 0-7.71-7.26-.97-8.07zm47.68 13.83a4.3 4.3 0 0 1 1.87.42 4 4 0 0 1 -1.9 7.64h-134.31a4 4 0 0 1 -1.89-7.64 4.286 4.286 0 0 1 1.86-.42zm23.43 13.82a4.11 4.11 0 0 1 2.44.79 4.011 4.011 0 0 1 -2.45 7.28h-181.2a4.015 4.015 0 0 1 -2.46-7.28 4.132 4.132 0 0 1 2.44-.79zm16.48 13.83a4.106 4.106 0 0 1 2.87 1.16 4.019 4.019 0 0 1 -2.87 6.9h-214.18a4.019 4.019 0 0 1 -2.87-6.9 4.082 4.082 0 0 1 2.86-1.16zm12.44 13.82a4.081 4.081 0 0 1 3.2 1.55 4.022 4.022 0 0 1 -3.2 6.51h-239.06a4.025 4.025 0 0 1 -3.21-6.51 4.1 4.1 0 0 1 3.21-1.55zm9.55 13.82a4.035 4.035 0 1 1 0 8.07h-258.16a4.035 4.035 0 1 1 -.01-8.07zm7.27 13.83a4.03 4.03 0 1 1 0 8.06h-396.38a4 4 0 0 1 -2.46-7.31 4.311 4.311 0 0 1 2.44-.75zm5.32 13.82a4.035 4.035 0 1 1 0 8.07h-417.8a4.017 4.017 0 0 1 -3.07-6.74 4.193 4.193 0 0 1 3.06-1.33zm3.59 13.83a4.03 4.03 0 1 1 0 8.06h-431.96a4.022 4.022 0 0 1 -3.51-6.11 4.1 4.1 0 0 1 3.51-1.95zm2 13.82a4.035 4.035 0 1 1 0 8.07h-440.76a4.036 4.036 0 0 1 -3.83-5.44 4.08 4.08 0 0 1 3.83-2.63zm2.98 13.83a1.556 1.556 0 0 1 1.55 1.57 6.508 6.508 0 0 1 -6.55 6.49h-442.54a4.03 4.03 0 1 1 0-8.06zm-3.52 13.82a4.035 4.035 0 0 1 0 8.07h-444.43a4.771 4.771 0 0 1 -4.81-4.74 3.342 3.342 0 0 1 3.36-3.33zm-2.55 13.83a4.03 4.03 0 1 1 0 8.06h-441.21a4.03 4.03 0 1 1 0-8.06z" fill="url(#a)"/></g></g></svg>

      </span>
      <router-link to="/files" v-slot="{ href, route, navigate, isActive, isExactActive, router }">
        <a :href="href" @click="navigate" :class="[(isActive || $router.currentRoute.path==='/projects' || $router.currentRoute.path==='/') && 'router-link-active', isExactActive && 'router-link-exact-active']">
          <span>{{$t("menu.files")}}</span>
        </a>
      </router-link>
      <router-link to="/dashboard"><span>{{$t("menu.history")}}</span></router-link>
      <router-link to="/printers"><span>{{$t("menu.printers")}}</span></router-link>
      <router-link to="/profiles"><span>{{$t("menu.profiles")}}</span></router-link>
      <!--<router-link to="/download"><span>{{$t("menu.download")}}</span></router-link>-->
      <b-nav-item href="https://imprinta.freshservice.com/support/home?login_error=true" target="_blank">{{$t("menu.support")}}</b-nav-item>
    </div>
    <user-menu></user-menu>
  </header>
</template>

<script>
  import {mapGetters} from 'vuex'
  import UserMenu from "./UserMenu";
  export default {
    name: "NavBar",
    components: {
      UserMenu
    },
    data() {
      return {
        user: {
          email: 'username@gmail.com',
          subscription: 'Enterprise',
          balance: '100€',
          name: 'Michael Graves',
          storage: '100GB',
        }
      }
    },
    computed: {
      ...mapGetters(['userData'])
    }
  }
</script>


<style lang="scss">
  @import ".././scss/theme";
  .logo{
    height: 26px;
    width: auto;
    margin-right: 20px;
  }
  .cursor-pointer{
    cursor: pointer;
  }
  .nav--main {
    color: white;
    background-color: $c-secondary;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $s-no-container-padding;
    margin-bottom: 24px;

    &--left {
      display: flex;
      align-items: center;
      text-align: center;

      a {
        display: block;
        position: relative;
        color: inherit;
        margin: 8px;
        padding: 4px 14px;
        font-size: 15px;
        font-weight: 300;
        z-index: 1;
        transition: all .2s;
        text-decoration: none;

        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -20px;
          width: 100%;
          height: 1px;
          border-radius: $s-x-small-border-radius $s-x-small-border-radius 0 0;
          background: transparent;
          transition: height .2s;
        }

        &:hover:not(.router-link-active ) {
          //background: rgba($c-black, .06);
          transition: .4s;
          color: $c-primary;
          &:after {
            transition: height .4s;
            background-color: $c-primary;
            height: 5px;
          }
        }

        &.router-link-active {
          color: $c-primary;
          font-weight: 600;
          cursor: inherit;
          &:after {
            transition: .3s;
            height: 3px;
            background: $c-primary;
          }
        }
      }
    }

    &--right {
      margin-right: 24px;

      p {
        margin: auto 0;
      }

      &__account {
        .dropdown {
          .btn {
            color: $c-primary;
            border: 0;
            padding: 0;
            height: fit-content;
            line-height: unset;
            text-transform: none;
            font-weight: 500;
          }
          p.b-dropdown-text {
            padding: $s-no-container-padding;
            font-size: 14px;
            font-weight: normal;
            p {
              line-height: 1.8;
            }
          }
          &-item {
            color: $c-text-gray;
            text-decoration: underline;
            padding: 4px $s-no-container-padding-v;
            font-size: 14px;
            transition: .1s all;
            &:hover {
              background: none;
              color: inherit;
              transition: .2s all;
            }
          }
        }
      }

      &__money {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;

        &__balance {
          font-weight: 500;
          margin-left: 8px;
          color: $c-primary;
        }
      }
    }
  }
</style>
